<template>
    <div class="">

        <div class="el-container" style="margin-bottom: 16px">
            <div class="el-col-20">
                <h3>
                    Quản lý cấu hình
                </h3>
            </div>
        </div>

        <VueGoodTable
                mode="remote"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-per-page-change="onPerPageChange"
                @on-search="onSearch"
                :columns="columns"
                :rows="documents"
                :totalRows="totalRecords"
                :line-numbers="true"
                :search-options="{
                    enabled: true,
                    placeholder: 'Tìm kiếm'
                }"
                :pagination-options="{
                    enabled: true,
                    mode: 'records',
                    rowsPerPageLabel: 'Số hàng mỗi trang',
                    nextLabel: 'Trang sau',
                    prevLabel: 'Trang trước',
                    ofLabel: 'trong'
                 }">


            <div slot="emptystate">
                Danh sách trống
            </div>

            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field === 'sendTime'">
                    {{formatTime(props.formattedRow[props.column.field])}}
                </span>
                <span v-else>
                    <span v-if="props.formattedRow[props.column.field] != null">
                        {{props.formattedRow[props.column.field]}}
                    </span>
                </span>
            </template>
            <template slot="loadingContent">
                <span class="vgt-loading__content">
                      Đang tải...
                </span>
            </template>
        </VueGoodTable>

    </div>
</template>

<script>
    import {VueGoodTable} from 'vue-good-table'
    import '@/assets/css/vue-good-table.css'
    import moment from 'moment'
    import 'moment/locale/vi'
    import {DownloadType} from '@/constants/DoITConstant'
    import {apiGetDocumentStateByStateId} from '@/services/document_management_service'
    import {apiGetAllMailHistory} from '@/services/root_dashboard_service'

    export default {
        name: 'MailHistoryList',
        components: {
            VueGoodTable
        },
        props: {},
        data: function () {
            return {
                columns: [],
                DownloadType: DownloadType,
                totalRecords: 0,
                serverParams: {
                    sortAscending: false,
                    sortField: 'key',
                    page: 0,
                    size: 10
                },
                documents: [],
            }
        },
        mounted() {
            // console.log('documents', this.documents)

            this.columns = [
                {
                    label: 'Email',
                    field: 'receiverEmail',
                    filterable: true
                },
                {
                    label: 'Type',
                    field: 'type',
                    type: 'string',
                    filterable: false
                },
                {
                    label: 'Time',
                    field: 'sendTime',
                },
            ]
            setInterval(this.loadItems,  60 * 1000)
        },
        methods: {
            formatStateValue(state_id) {
                return apiGetDocumentStateByStateId(state_id)[
                    'descriptionUser'
                    ]
            },
            formatTime(uploadTime) {
                let mm = moment(uploadTime)
                if (mm.isValid())
                    return moment(uploadTime).format('HH:mm:ss DD/MM/YYYY')
                else
                    return ""
            },

            onSearch(params) {
                this.serverParams.searchKey = params.searchTerm
                this.loadItems()
            },

            onPageChange(params) {
                this.serverParams.page = params.currentPage - 1
                this.loadItems()
            },

            onPerPageChange(params) {
                this.serverParams.size = params.currentPerPage
                this.loadItems()
            },

            onSortChange(params) {
                this.serverParams.sortAscending = params[0].type === 'asc'
                this.serverParams.sortField = params[0].field
                this.serverParams.page = 0
                this.loadItems()
            },
            async loadItems() {
                if (this._inactive) return
                let responseAllDocument = await apiGetAllMailHistory(this.serverParams)
                let documents = responseAllDocument.data
                this.documents = documents
                this.totalRecords = responseAllDocument.meta.total
            }
        }
    }
</script>

<style scoped>
    .icn {
        color: #0063fa;
        cursor: pointer;
    }

    .share {
        color: #61a4ff;
    }
</style>
